<div class="desktop-width-limiter page-padding task-page">
    <ng-container *ngIf="loading">
        <div class="loading">
            <mat-progress-spinner
            class="loading-spinner"
            [diameter]="250"
            mode="indeterminate"
            color="primary"
            >
            </mat-progress-spinner>
            <div class="loading-text"><h1>Laden...</h1></div>
        </div>
    </ng-container>
    <div *ngIf="!loading && error" class="error">
        <h1>- {{ 'sebbie_ranking.error_loading_tasks' | translate }} -</h1>
    </div>
    <div *ngIf="!loading && !error">
        <header-content-task 
            [profile]="profile"
            [currentPromotionAction]="currentPromotionAction" 
            [availableTasks]="availableTasks"
            [sebbiesReceived]="sebbiesReceived"
        />
        <div *ngIf="availableTasks.length > 0" class="row overview-items">
            <div class="col-xs-12 col-sm-6 col-md-6 col-lg-4 col-xl-3 col-xxxl-2 overview-item "
                *ngFor="let task of availableTasks; let i = index"
            >
                <task-card
                    [task]="task"
                    [numberInList]="i + 1"
                    [completedCount]="numberOfTimesTaskCompleted(task.id)"
                />
            </div>
        </div>
        <div *ngIf="availableTasks.length === 0" class="no-tasks">
            <h1>- {{'sebbie_ranking.no_tasks_promotion' | translate}} -</h1>
        </div>
    </div>
</div>